export default __webpack_public_path__ + "static/nimhns-33401a6a2f448cceb9818f3166ac7a65.png";